import React from 'react';
import DeliverySlotsDataTable from './DeliverySlotsDataTable';

const DeliverySlotsPage = () => {
  return <DeliverySlotsDataTable />;
};

export default DeliverySlotsPage;
